'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unsubscribe = unsubscribe;

var _actions = require('../helpers/actions');

var _unsubscribe = require('../helpers/unsubscribe');

var getUnsubscribePath = function getUnsubscribePath(scope) {
  switch (scope) {
    case _unsubscribe.Scope.abandonedCartReminder:
      return '/abandoned_cart_mail/unsubscribe';
    case _unsubscribe.Scope.full:
      return '/abandoned_cart_mail/unsubscribe_full';
    default:
      throw new Error('Unrecognized unsubscribe scope \'' + scope + '\'');
  }
};

function unsubscribe() {
  var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _unsubscribe.Scope.abandonedCartReminder;

  var path = getUnsubscribePath(scope);

  return function (dispatch) {
    return dispatch({
      scope: scope,
      token: token,
      type: 'UNSUBSCRIBE',
      promise: function promise(_ref) {
        var api = _ref.api;
        return (0, _actions.handleErrors)(api(path).post({ token: token }));
      }
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./shared/actions/unsubscribe.js
// module id = 2431
// module chunks = 0